<app-drop-down-grid-new
  [grid_columns]="grid_columns"
  [placeholder]="'Select Consumer...'"
  [showClearButton]="showClearButton"
  [disabled]="disabled"
  [dataSource]="dataSource"
  [remoteOperations]="remoteOperations"
  [valueExpr]="'id'"
  [displayExpr]="helper.displayExpr"
  [(value)]="value"
  (valueChange)="valueChange.emit($event)"
  (valueChanged)="valueChanged.emit($event)"
  (grid_cellPrepared)="grid_cellPrepared.emit($event)"
  (focusout)="focusOut.emit($event)"
  [popup_width]="350"
  [popup_height]="300">
  <ng-content></ng-content>
</app-drop-down-grid-new>
